<div class="actionArea__options__amount">
  <div class="actionArea-select-packaging-clickarea" (click)="selectClicked.emit()">
    {{header}}
    <!--SelectionArea-->
    <div class="actionArea__options__amount__packaging bold" tappable *ngIf="selectionEnabled">
      <span *ngIf="selectedPackagingUnit"
        >{{ selectedPackagingUnit.unit | articleUnitPipe }} ({{ selectedPackagingUnit.quantity }} {{
        'careproposal.create.shoppingCart-listitems.unit' | translate }})</span
      >
      <span *ngIf="selectedTimePeriod">{{ selectedTimePeriod| timePeriodPipe }}</span>
      <span *ngIf="!selectedPackagingUnit && !selectedTimePeriod"
        >{{ 'careproposal.create.shoppingCart-listitems.notValid' | translate }}</span
      >
      <ion-icon name="chevron-down-outline"></ion-icon>
    </div>
  </div>
  <!--ChangeAmount-->
  <div class="actionArea__options__amount__change">
    <div class="actionArea__options__amount__change__deleteAmount" tappable (click)="minusClicked.emit()">
      <ion-icon name="remove"></ion-icon>
    </div>
    <input
      class="actionArea__options__amount__change__amountInput bold"
      type="number"
      min="1"
      step="1"
      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
      oninput="validity.valid||(value=1);"
      [(ngModel)]="value"
      (ngModelChange)="valueChange.emit(value)"
    />
    <div class="actionArea__options__amount__change__addAmount" tappable (click)="plusClicked.emit()">
      <ion-icon name="add"></ion-icon>
    </div>
  </div>
</div>
